// (function () {
//     async function saveStorefrontToCart() {
//         const storefront =
//             localStorage.getItem('omni_storefront');

//         if (!storefront) {
//             console.log(
//                 'No storefront referral found.'
//             );

//             return;
//         }

//         try {
//             const response = await fetch(
//                 '/cart/update.js',
//                 {
//                     method: 'POST',
//                     headers: {
//                         'Content-Type': 'application/json'
//                     },
//                     body: JSON.stringify({
//                         attributes: {
//                             storefront_slug: storefront
//                         }
//                     })
//                 }
//             );

//             if (!response.ok) {
//                 throw new Error(
//                     `Cart update failed: ${response.status}`
//                 );
//             }

//             const cart = await response.json();

//             console.log(
//                 'Storefront saved to Shopify cart:',
//                 cart.attributes
//             );

//         } catch (error) {
//             console.error(
//                 'Failed to save storefront to cart:',
//                 error
//             );
//         }
//     }

//     saveStorefrontToCart();
// })();

(function () {
    // 1. Capture referral from the URL
    const params = new URLSearchParams(window.location.search);
    const ref = params.get('ref');

    if (ref) {
        const storefront = ref.trim();

        if (storefront) {
            localStorage.setItem(
                'omni_storefront',
                storefront
            );

            console.log(
                'Storefront referral saved:',
                storefront
            );
        }
    }

    const storefront =
        localStorage.getItem('omni_storefront');

    if (!storefront) {
        console.log(
            'No storefront referral found.'
        );

        return;
    }

    console.log(
        'Using storefront referral:',
        storefront
    );

    // 2. Save the stored referral to the Shopify cart
    async function saveStorefrontToCart() {
        const storefront =
            localStorage.getItem('omni_storefront');

        if (!storefront) {
            console.log(
                'No storefront referral found.'
            );

            return;
        }

        try {
            const response = await fetch(
                '/cart/update.js',
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        attributes: {
                            storefront_slug: storefront
                        }
                    })
                }
            );

            if (!response.ok) {
                throw new Error(
                    `Cart update failed: ${response.status}`
                );
            }

            const cart = await response.json();

            console.log(
                'Storefront saved to Shopify cart:',
                cart.attributes
            );

        } catch (error) {
            console.error(
                'Failed to save storefront to cart:',
                error
            );
        }
    }

    saveStorefrontToCart();

    /*
     * 4. Apply the same storefront value
     *    as the Shopify discount code.
     *
     * Example:
     * omni_storefront = VITAMINBOSS
     *
     * Shopify discount:
     * VITAMINBOSS
     */
    function applyDiscountCode() {
        const discountCode =
            localStorage.getItem('omni_storefront');

        if (!discountCode) {
            console.log(
                'No storefront discount code found.'
            );

            return;
        }

        /*
         * Prevent repeatedly applying the same
         * discount on every page load.
         */
        const appliedDiscount =
            sessionStorage.getItem(
                'omni_discount_applied'
            );

        if (appliedDiscount === discountCode) {
            console.log(
                'Discount already applied this session:',
                discountCode
            );

            return;
        }

        sessionStorage.setItem(
            'omni_discount_applied',
            discountCode
        );

        /*
         * Shopify discount URL.
         */
        const redirectPath =
            window.location.pathname;

        const discountUrl =
            '/discount/' +
            encodeURIComponent(discountCode) +
            '?redirect=' +
            encodeURIComponent(redirectPath);

        console.log(
            'Applying Shopify discount:',
            discountCode
        );

        window.location.href = discountUrl;
    }

    /*
     * Only apply the discount when a NEW ref
     * was actually provided in the URL.
     *
     * This prevents normal page navigation from
     * repeatedly redirecting the customer.
     */
    if (ref) {
        applyDiscountCode();
    }
})();